<template>
  <div>
    <Header></Header>
    <container-nav>
      <template slot-scope="p">
        <Nav :list="p.list" :styles="p.styles" sticky></Nav>
      </template>
    </container-nav>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>
<script>
  import containerNav from '@/containers/nav/containerNav'
  import Nav from '@/components/hsm/nav/index'
  import Header from '@/pages/others/header'
  import Footer from '@/pages/others/footer'
  export default {
    components: { Header, Footer, containerNav, Nav }
  }
</script>



// WEBPACK FOOTER //
// src/pages/front/pageIndex.vue